var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetDropIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 51,
    viewBox: "0 0 32 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 47C19 45.3431 17.6569 44 16 44C14.3431 44 13 45.3431 13 47C13 48.6569 14.3431 50 16 50C17.6569 50 19 48.6569 19 47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47C19 45.3431 17.6569 44 16 44C14.3431 44 13 45.3431 13 47C13 48.6569 14.3431 50 16 50C17.6569 50 19 48.6569 19 47Z",
    stroke: "#262F39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 23.1863 28 26.6667 23.3333 32C17.1249 39.0954 16 45.8182 16 45.8182C16 45.8182 14.6667 38.6667 8.6667 32C3.8667 26.6667 0 23.1863 0 16C0 7.1634 7.1634 0 16 0C24.8366 0 32 7.1634 32 16Z",
    fill: "#171717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31C24.2843 31 31 24.2843 31 16Z",
    fill: "#1677FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_399",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 28
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 2H2V30H30V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63667 16.6562H14.998V22.0176C14.998 22.5625 15.4463 23.0195 16 23.0195C16.5537 23.0195 17.002 22.5625 17.002 22.0176V16.6562H22.3633C22.9082 16.6562 23.3652 16.208 23.3652 15.6543C23.3652 15.1006 22.9082 14.6523 22.3633 14.6523H17.002V9.29096C17.002 8.74606 16.5537 8.28906 16 8.28906C15.4463 8.28906 14.998 8.74606 14.998 9.29096V14.6523H9.63667C9.09177 14.6523 8.63477 15.1006 8.63477 15.6543C8.63477 16.208 9.09177 16.6562 9.63667 16.6562Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetDropIconNew);
export default __webpack_public_path__ + "static/media/AssetDropIconNew.d2f238f26033d31fb193dfe2a38bdf50.svg";
export { ForwardRef as ReactComponent };